var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-page"}},[_c('main-wrapp'),_c('explanationWrapp'),_c('wrapVideo'),_c('reportWrap'),_c('footerUp2'),_vm._v(" "),(false && !_vm.remove)?_c('footerUp'):_vm._e(),_c('homeBlogWrapper'),_c('footerWrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }